<template>
  <div class="appWrapper">
    <div v-if="!showForm" class="loading-shade">
      <div class="loading-spinner"></div>
    </div>
    <div>
      <div v-if="isLoading" class="loading-shade">
        <div class="loading-spinner"></div>
      </div>
      <h1 class="headlineText">OWNER</h1>

      <div class="infoData infoDataFirst">
        {{ Title }} {{ FirstName }} {{ LastName }}
      </div>
      <div class="infoData">
        {{ Email }}
      </div>
      <div class="infoData">
        {{ MobilePhone }}
      </div>
      <div class="infoData infoDataLast">
        {{ Region__c }} / {{ NSA_Bookingdate }}
      </div>


      <div class="tabs">
        <button
          type="button"
          @click="tab = 1"
          class="ctaPrimary font-icon"
          :class="tab == 1 ? 'formSubmitBtn' : 'formTabBtn'"
        >
          CHANGE BOOKING
        </button>
        <button
          type="button"
          @click="tab = 2"
          class="ctaPrimary font-icon"
          :class="tab == 2 ? 'formSubmitBtn' : 'formTabBtn'"
        >
          CHANGE GUEST
        </button>
        <button
          type="button"
          @click="tab = 3"
          class="ctaPrimary font-icon"
          :class="tab == 3 ? 'formSubmitBtn' : 'formTabBtn'"
        >
          CANCEL BOOKING
        </button>
      </div>


      <div v-if="tab == 1">


      <div class="alert success" v-if="success">
        <span class="closebtn" @click="success = false">&times;</span>
        <strong>Success!</strong> Your booking has been successfully updated.
      </div>

        <form @submit.prevent="formSubmitChangeDate" id="changeDate">
          <div class="form-group heroForm">
            <label for="region">Region</label>
            <select
              class="customSelect"
              name="region"
              v-model="Region__c"
              required
            >
              <option default disabled value="">Select from list</option>
              <option value="Botswana">Botswana</option>
              <option value="Eastern Cape">Eastern Cape</option>
              <option value="Freestate">Freestate</option>
              <option value="Gauteng">Gauteng</option>
              <option value="Kwazulu-Natal">Kwazulu-Natal</option>
              <option value="Lesotho">Lesotho</option>
              <option value="Limpopo">Limpopo</option>
              <option value="Mpumalanga">Mpumalanga</option>
              <option value="Namibia">Namibia</option>
              <option value="North West">North West</option>
              <option value="Northern Cape">Northern Cape</option>
              <option value="Swaziland">Swaziland</option>
              <option value="Western Cape">Western Cape</option>
            </select>
          </div>

          <div class="form-group heroForm">
            <label for="date">Booking Date</label>
            <flat-pickr
              class="customDatePicker text"
              v-model="NSA_Bookingdate__c"
              :config="config"
              :disabled="isDatePickerDiabled"
            ></flat-pickr>
            <span
              v-if="dateError"
              class="errorLabel isError"
              style="color: red"
              >{{ dateErrorMessage }}</span
            >
          </div>

          <section>
            <span
              v-if="dateError"
              class="errorLabel isError"
              style="color: red"
              >{{ errorMessage }}</span
            >
          </section>
          <button type="submit" class="ctaPrimary font-icon formSubmitBtn">
            SUBMIT
          </button>
        </form>
      </div>

      <div v-if="tab == 2">

      <div class="alert success" v-if="successg">
        <span class="closebtn" @click="successg = false">&times;</span>
        <strong>Success!</strong> Your guest information has been successfully updated.
      </div>

      
        <form @submit.prevent="formSubmitChangeGuest" id="changeDate">
          <section>

            <div class="form-group heroForm">
              <label for="NSA_Inviteamate__c">Want to invite a mate? </label>

              <select
                class="customSelect"
                name="NSA_Inviteamate__c"
                v-model="NSA_Inviteamate__c"
                onchange=""
                required
              >
                <option value="true">YES</option>
                <option value="false" default selected>NO</option>
              </select>
            </div>
          </section>

          <section v-if="NSA_Inviteamate__c == 'true' || NSA_Inviteamate__c == true">
            <div class="form-group heroForm">
              <label for="friend_name">Friend's First Name</label>
              <input
                type="text"
                class="heroInputArea text"
                id="NSA_InviteyourMateFirstName__c"
                v-model="NSA_InviteyourMateFirstName__c"
                required
              />
            </div>
            <div class="form-group heroForm">
              <label for="friend_name">Friend's Last Name</label>
              <input
                type="text"
                class="heroInputArea text"
                id="NSA_InviteyourMateLastName__c"
                v-model="NSA_InviteyourMateLastName__c"
                required
              />
            </div>
            <div class="form-group heroForm">
              <label for="friend_mob">Friend's Mobile</label>
              <input
                type="text"
                class="heroInputArea text"
                id="NSA_InviteyourMateMobile__c"
                v-model="NSA_InviteyourMateMobile__c"
                required
              />
              <span v-if="!isFriendsMobileValid" style="color: red"
                >Invalid mobile number. Please enter a valid number.</span
              >
            </div>
            <div class="form-group heroForm">
              <label for="friend_email">Friend's E-mail</label>
              <input
                type="email"
                class="heroInputArea text"
                id="NSA_InviteyourMateEmail__c"
                v-model="NSA_InviteyourMateEmail__c"
                required
              />
            </div>
          </section>

          <section>
            <span
              v-if="dateError"
              class="errorLabel isError"
              style="color: red"
              >{{ errorMessage }}</span
            >
          </section>
          <button type="submit" class="ctaPrimary font-icon formSubmitBtn">
            SUBMIT
          </button>
        </form>
      </div>


      <div v-if="tab == 3">
        <form @submit.prevent="formSubmitChangeStatus" id="changeDate">
          <div class="form-group heroForm">
            <label for="region">Reason for cancellation</label>
            <textarea 
            class="heroInputArea text"
              v-model="Comments__c"
              >
            </textarea>
    
          </div>

          

          <section>
            <span
              v-if="dateError"
              class="errorLabel isError"
              style="color: red"
              >{{ errorMessage }}</span
            >
          </section>
          <button type="submit" class="ctaPrimary font-icon formSubmitBtn">
            SUBMIT
          </button>
        </form>
      </div>

    </div>
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import {
  updateSalesforceLead,
  base_be_url,
  base_be_booking_url,
} from "@/utils/api";
import { validateMobile, dietaryOptions } from "@/utils/constants";
import ThankYou from "@/components/ThankYou.vue";
import FlatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import adobeAnalytics from "@/plugin/analytics";

export default {
  components: {
    ThankYou,
    FlatPickr,
  },
  data() {
    return {
      tab: 0,
      success: false,
      successg:false,
      isFocused: false,
      isDatePickerDiabled: true,
      Comments__c: "",
      config: {
        disable: [new Date()],
        defaultDate: null,
        dateFormat: "Y-m-d", // Date format
      },
      showFriend: false,
      showForm: false,
      CID__c: "ZA-NISSAN-ACBRANDWELCOMEOWNER",
      Dietary_Requirements__c: "",
      Email: "",
      FirstName: "",
      LastName: "",
      Has_Opted_Out_Of_Marketing_Material__c: false,
      Id: "",
      LeadSource: "Online – Website",
      MobilePhone: "",
      NSA_4x4_4x2__c: "",
      NSA_Alternativebookingdate__c: "",
      NSA_Areyoubringingkids__c: "NO",
      NSA_Whataretheirages__c: "",
      NSA_AttendedAC__c: false,
      NSA_Bookingdate__c: null,
      NSA_Bookingdate: "",
      NSA_Completeddate__c: "",
      NSA_Didnotattend__c: false,
      NSA_DrivingExperience__c: "",
      NSA_Inviteamate__c: false,
    
      Name: "",
      Title: "",
      Region__c: "",
      isFriendsMobileValid: true,
      isError: false,
      dateError: false,
      errorMessage: "",
      dateErrorMessage: "",
      showThankYouMessage: false,
      dietaryOptions: dietaryOptions,
      selectedDietaryRequirements: [],
      dietaryRequirementsOnSubmit: false,
      isLoading: false,
      dateValid: false,
      disabledDates: [],
      availableDates: [],
      toDate:
        new Date().getFullYear() +
        "-" +
        String(new Date().getMonth() + 1).padStart(2, "0") +
        "-" +
        new Date().getDate(),
      fromDate: new Date(
        new Date().getFullYear(),
        new Date().getMonth() + 3,
        new Date().getDate()
      )
        .toISOString()
        .split("T")[0],
      state: {
        disabledDates: {
          to: null,
          from: null,
          dates: [],
          preventDisableDateSelection: true,
        },
      },
    };
  },
  watch: {
    NSA_Bookingdate__c(newDate, oldDate) {
      // Check if the date has actually changed
      if (newDate !== oldDate) {
        this.fetchDataByDate(); // Call the new function
      } else {
        this.dateValid = true;
      }
    },
    Region__c(newRegion, oldRegion) {
      this.dateErrorMessage = "";
      let load = false;
      if (this.isLoading === false) {
        load = true;
        this.isLoading = true;
      }
      if (newRegion !== oldRegion) {
        const datesForRegion =
          this.availableDates[newRegion]
            ?.filter((date) => date.slots > 0)
            ?.map((date) => date.date) || [];
        const today = new Date();
        const todayDate = new Date(
          today.getFullYear(),
          today.getMonth(),
          today.getDate()
        );

        const datesAfterToday = datesForRegion.filter((date) => {
          const [year, month, day] = date.split("-");
          const currentDate = new Date(year, month - 1, day);
          return currentDate > todayDate;
        });

        datesAfterToday.sort((a, b) => new Date(a) - new Date(b));
        const inputElement = document.querySelector(".flatpickr-input");
        this.NSA_Bookingdate__c = null;

        if (datesAfterToday.length > 0) {
          this.isDatePickerDiabled = false;
          const minDate = new Date(datesAfterToday[0]);
          const maxDate = new Date(datesAfterToday[datesAfterToday.length - 1]);

          const missingDates = [];

          for (
            let currentDate = minDate;
            currentDate <= maxDate;
            currentDate.setDate(currentDate.getDate() + 1)
          ) {
            const formattedDate = currentDate.toISOString().slice(0, 10);
            if (!datesAfterToday.includes(formattedDate)) {
              missingDates.push(formattedDate);
            }
          }

          const missingDatesInDateFormat = missingDates.map(
            (dateString) => new Date(dateString)
          );

          console.log(
            missingDatesInDateFormat,
            datesAfterToday,
            datesAfterToday.length,
            datesAfterToday[0],
            datesAfterToday[datesAfterToday.length - 1]
          );

          // if datesAfterToday is empty, then set the date to today

          this.config = {
            // minDate: new Date(datesAfterToday[0]),
            // maxDate: new Date(datesAfterToday[datesAfterToday.length - 1]),
            enable: datesAfterToday,
            disable: missingDatesInDateFormat,
            dateFormat: "Y-m-d",
          };
        } else {
          this.isDatePickerDiabled = true;
        }

        if (load) {
          setTimeout(() => {
            this.isLoading = false;
          }, 500);
        }
      }
    },
    // NSA_4x4_4x2__c(newDrive, oldDrive) {
    //   if (newDrive === "4x2") {
    //     this.NSA_DrivingExperience__c = "Defensive";
    //   } else {
    //     this.NSA_DrivingExperience__c = "";
    //   }
    // },
  },
  methods: {
    async fetchDataByDate() {
      try {
        this.isLoading = true;
        const apiUrl = `${base_be_url}?date=${this.NSA_Bookingdate__c}`;
        const response = await axios.get(apiUrl);
        if (response.data.count < 21) {
          this.dateValid = true;
          this.dateError = false;
          this.dateErrorMessage = "";
        } else {
          this.dateValid = false;
          this.dateError = true;
          this.dateErrorMessage = "Please select a date";
        }
      } catch (error) {
        console.error("Error fetching data by date:", error);
      } finally {
        setTimeout(() => {
          this.isLoading = false;
        }, 1000);
      }
    },

    async formSubmitChangeStatus(){
      const salesForceId = this.$route.query.sales_force_id;
      this.isError = false;
      this.errorMessage = "";
      this.dateError = false;
      this.dateErrorMessage = "";
      // if (this.NSA_Bookingdate__c == null) {
      //   this.dateError = true;
      //   this.dateErrorMessage = "Please select a valid date";
      //   return false;
      // }

      const postData = {
        CID__c: this.CID__c,
        Title: this.Title,
        Firstname: this.FirstName,
        Lastname: this.LastName,
        Email: this.Email,
        MobilePhone: this.MobilePhone,
        LeadSource: this.LeadSource,
        NSA_Bookingdate__c:  new Date(this.NSA_Bookingdate).toISOString().split(".")[0] +
          ".000",
         
        NSA_4x4_4x2__c: this.NSA_4x4_4x2__c,
        NSA_Areyoubringingkids__c: this.NSA_Areyoubringingkids__c,
        NSA_DrivingExperience__c: this.NSA_DrivingExperience__c,
        NSA_Inviteamate__c:
          this.NSA_Inviteamate__c == "" ? false : this.NSA_Inviteamate__c,
        Dietary_Requirements__c: this.Dietary_Requirements__c,
        // NSA Inviteamate  c
        NSA_Whataretheirages__c: this.NSA_Whataretheirages__c,

        NSA_InviteyourMateFirstName__c: "",
          NSA_InviteyourMateLastName__c: "",
          NSA_InviteyourMateMobile__c: "",
          NSA_InviteyourMateEmail__c: "",

        Region__c: this.Region__c,
        Has_Opted_Out_Of_Marketing_Material__c:
          this.Has_Opted_Out_Of_Marketing_Material__c,
        owner: true,
        Comments__c: this.Comments__c,
        status:"Cancelled",
      };

      if (this.NSA_Inviteamate__c === "true") {
        postData.NSA_InviteyourMateFirstName__c =
          this.NSA_InviteyourMateFirstName__c;
        postData.NSA_InviteyourMateLastName__c =
          this.NSA_InviteyourMateLastName__c;
        postData.NSA_InviteyourMateMobile__c = this.NSA_InviteyourMateMobile__c;
        postData.NSA_InviteyourMateEmail__c = this.NSA_InviteyourMateEmail__c;
      }


      try {
        this.isLoading = true;
        this.success = false;
        const response = await updateSalesforceLead(
          `${base_be_url}?lead_id=${salesForceId}`,
          postData
        );
        // Handle the successful response
        if (response.data == "" || response.data.success) {
          this.success = true;
          this.showThankYouMessage = true;
          // Adobe Analytics Starts
          let event_happened = "Form Complete | Owner";
          let events = "event51";
          let event_126 = "";
          let eVar14 = event_happened;
          // let eVar14 = event_happened + "|" + url

          adobeAnalytics(
            "R",
            "",
            "",
            "",
            "",
            "EN",
            event_happened,
            "",
            "",
            "",
            event_126,
            events,
            "",
            "",
            eVar14
          );

          // booking-canceled 
          this.$router.push('/booking-canceled');
          // Adobe Analytics Ends
        } else {
          this.errorMessage = response.data.message;
          this.isError = true;
          console.error("Error submitting form:", response.data.message);
        }
      } catch (error) {
        this.errorMessage = error;
        this.isError = true;
      } finally {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      }
    },

    async formSubmitChangeGuest(){
      const salesForceId = this.$route.query.sales_force_id;
      this.isError = false;
      this.errorMessage = "";
      this.dateError = false;
      this.dateErrorMessage = "";
      // if (this.NSA_Bookingdate__c == null) {
      //   this.dateError = true;
      //   this.dateErrorMessage = "Please select a valid date";
      //   return false;
      // }

      const postData = {
        CID__c: this.CID__c,
        Title: this.Title,
        Firstname: this.FirstName,
        Lastname: this.LastName,
        Email: this.Email,
        MobilePhone: this.MobilePhone,
        LeadSource: this.LeadSource,
        NSA_Bookingdate__c:  new Date(this.NSA_Bookingdate).toISOString().split(".")[0] +
          ".000",
         
        NSA_4x4_4x2__c: this.NSA_4x4_4x2__c,
        NSA_Areyoubringingkids__c: this.NSA_Areyoubringingkids__c,
        NSA_DrivingExperience__c: this.NSA_DrivingExperience__c,
        NSA_Inviteamate__c:
          this.NSA_Inviteamate__c == "" ? false : this.NSA_Inviteamate__c,
        Dietary_Requirements__c: this.Dietary_Requirements__c,
        // NSA Inviteamate  c
        NSA_Whataretheirages__c: this.NSA_Whataretheirages__c,
        Region__c: this.Region__c,
        Has_Opted_Out_Of_Marketing_Material__c:
          this.Has_Opted_Out_Of_Marketing_Material__c,
        owner: true,
      };

      if (this.NSA_Inviteamate__c === "true" || this.NSA_Inviteamate__c === true) {
        postData.NSA_InviteyourMateFirstName__c =
          this.NSA_InviteyourMateFirstName__c;
        postData.NSA_InviteyourMateLastName__c =
          this.NSA_InviteyourMateLastName__c;
        postData.NSA_InviteyourMateMobile__c = this.NSA_InviteyourMateMobile__c;
        postData.NSA_InviteyourMateEmail__c = this.NSA_InviteyourMateEmail__c;
      }


      try {
        this.isLoading = true;
        this.successg = false;
        const response = await updateSalesforceLead(
          `${base_be_url}?lead_id=${salesForceId}`,
          postData
        );
        // Handle the successful response
        if (response.data == "" || response.data.success) {
          this.successg = true;
          this.showThankYouMessage = true;
          // Adobe Analytics Starts
          let event_happened = "Form Complete | Owner";
          let events = "event51";
          let event_126 = "";
          let eVar14 = event_happened;
          // let eVar14 = event_happened + "|" + url

          adobeAnalytics(
            "R",
            "",
            "",
            "",
            "",
            "EN",
            event_happened,
            "",
            "",
            "",
            event_126,
            events,
            "",
            "",
            eVar14
          );
          // Adobe Analytics Ends
        } else {
          this.errorMessage = response.data.message;
          this.isError = true;
          console.error("Error submitting form:", response.data.message);
        }
      } catch (error) {
        this.errorMessage = error;
        this.isError = true;
      } finally {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      }
    },

    
    async formSubmitChangeDate() {
      const salesForceId = this.$route.query.sales_force_id;
      this.isError = false;
      this.errorMessage = "";
      this.dateError = false;
      this.dateErrorMessage = "";
      if (this.NSA_Bookingdate__c == null) {
        this.dateError = true;
        this.dateErrorMessage = "Please select a valid date";
        return false;
      }

      const postData = {
        CID__c: this.CID__c,
        Title: this.Title,
        Firstname: this.FirstName,
        Lastname: this.LastName,
        Email: this.Email,
        MobilePhone: this.MobilePhone,
        LeadSource: this.LeadSource,
        NSA_Bookingdate__c:
          new Date(this.NSA_Bookingdate__c).toISOString().split(".")[0] +
          ".000",
        NSA_4x4_4x2__c: this.NSA_4x4_4x2__c,
        NSA_Areyoubringingkids__c: this.NSA_Areyoubringingkids__c,
        NSA_DrivingExperience__c: this.NSA_DrivingExperience__c,
        NSA_Inviteamate__c:
          this.NSA_Inviteamate__c == "" ? false : this.NSA_Inviteamate__c,
        Dietary_Requirements__c: this.Dietary_Requirements__c,
        // NSA Inviteamate  c
        NSA_Whataretheirages__c: this.NSA_Whataretheirages__c,
        Region__c: this.Region__c,
        Has_Opted_Out_Of_Marketing_Material__c:
          this.Has_Opted_Out_Of_Marketing_Material__c,
        owner: true,
      };

      if (this.NSA_Inviteamate__c === "true" || this.NSA_Inviteamate__c === true) {
        postData.NSA_InviteyourMateFirstName__c =
          this.NSA_InviteyourMateFirstName__c;
        postData.NSA_InviteyourMateLastName__c =
          this.NSA_InviteyourMateLastName__c;
        postData.NSA_InviteyourMateMobile__c = this.NSA_InviteyourMateMobile__c;
        postData.NSA_InviteyourMateEmail__c = this.NSA_InviteyourMateEmail__c;
      }


      try {
        this.isLoading = true;
        this.success = false;
        const response = await updateSalesforceLead(
          `${base_be_url}?lead_id=${salesForceId}`,
          postData
        );
        // Handle the successful response
        if (response.data == "" || response.data.success) {
          this.success = true;
          //this.NSA_Bookingdate = responseData.NSA_Bookingdate__c
          this.NSA_Bookingdate = this.NSA_Bookingdate__c;
          this.showThankYouMessage = true;
          // Adobe Analytics Starts
          let event_happened = "Form Complete | Owner";
          let events = "event51";
          let event_126 = "";
          let eVar14 = event_happened;
          // let eVar14 = event_happened + "|" + url

          adobeAnalytics(
            "R",
            "",
            "",
            "",
            "",
            "EN",
            event_happened,
            "",
            "",
            "",
            event_126,
            events,
            "",
            "",
            eVar14
          );
          // Adobe Analytics Ends
        } else {
          this.errorMessage = response.data.message;
          this.isError = true;
          console.error("Error submitting form:", response.data.message);
        }
      } catch (error) {
        this.errorMessage = error;
        this.isError = true;
      } finally {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      }
    },

    async formSubmit() {
      const salesForceId = this.$route.query.sales_force_id;
      this.isError = false;
      this.errorMessage = "";
      this.dateError = false;
      this.dateErrorMessage = "";

      if (this.NSA_Inviteamate__c) {
        this.isFriendsMobileValid = validateMobile(
          this.NSA_InviteyourMateMobile__c
        );
        if (!this.isFriendsMobileValid) {
          console.log("Invalid mobile number");
          return false;
        }
      } else if (this.NSA_Bookingdate__c == null) {
        this.dateError = true;
        this.dateErrorMessage = "Please select a valid date";
        return false;
      }

      this.dietaryRequirementsOnSubmit = true;
      if (this.selectedDietaryRequirements.length < 1) {
        return false;
      }

      const postData = {
        CID__c: this.CID__c,

        Title: this.Title,
        Firstname: this.FirstName,
        Lastname: this.LastName,
        Email: this.Email,
        MobilePhone: this.MobilePhone,
        LeadSource: this.LeadSource,
        NSA_Bookingdate__c:
          new Date(this.NSA_Bookingdate__c).toISOString().split(".")[0] +
          ".000",
        NSA_4x4_4x2__c: this.NSA_4x4_4x2__c,
        NSA_Areyoubringingkids__c: this.NSA_Areyoubringingkids__c,
        NSA_DrivingExperience__c: this.NSA_DrivingExperience__c,
        NSA_Inviteamate__c: this.NSA_Inviteamate__c ?? false,
        Dietary_Requirements__c: this.selectedDietaryRequirements.join(", "),
        Region__c: this.Region__c,
        Has_Opted_Out_Of_Marketing_Material__c:
          this.Has_Opted_Out_Of_Marketing_Material__c,
        owner: true,
      };

      if (this.NSA_Inviteamate__c === "true") {
        postData.NSA_InviteyourMateFirstName__c =
          this.NSA_InviteyourMateFirstName__c;
        postData.NSA_InviteyourMateLastName__c =
          this.NSA_InviteyourMateLastName__c;
        postData.NSA_InviteyourMateMobile__c = this.NSA_InviteyourMateMobile__c;
        postData.NSA_InviteyourMateEmail__c = this.NSA_InviteyourMateEmail__c;
      }

      if (this.NSA_Areyoubringingkids__c !== "NO") {
        postData.NSA_Whataretheirages__c = this.NSA_Whataretheirages__c;
      }

      try {
        this.isLoading = true;
        const response = await updateSalesforceLead(
          `${base_be_url}?lead_id=${salesForceId}`,
          postData
        );
        // Handle the successful response
        if (response.data == "" || response.data.success) {
          this.showThankYouMessage = true;
          // Adobe Analytics Starts
          let event_happened = "Form Complete | Owner";
          let events = "event51";
          let event_126 = "";
          let eVar14 = event_happened;
          // let eVar14 = event_happened + "|" + url

          adobeAnalytics(
            "R",
            "",
            "",
            "",
            "",
            "EN",
            event_happened,
            "",
            "",
            "",
            event_126,
            events,
            "",
            "",
            eVar14
          );
          // Adobe Analytics Ends
        } else {
          this.errorMessage = response.data.message;
          this.isError = true;
          console.error("Error submitting form:", response.data.message);
        }
      } catch (error) {
        this.errorMessage = error;
        this.isError = true;
      } finally {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      }
    },
    async fetchData() {
      this.state.disabledDates.to = new Date(this.toDate);
      this.state.disabledDates.from = new Date(this.fromDate);
      try {
        this.isLoading = true;
        const salesForceId = this.$route.query.sales_force_id;
        const apiUrl = `${base_be_url}?sales_force_id=${salesForceId}`;

        axios
          .get(apiUrl)
          .then((response) => {
            // Handle the successful response
            const res = response.data;

            if (res.success === true) {
              const responseData = res.response.records[0];
              this.Id = responseData.Id || "";
              this.Name = responseData.Name || "";
              this.Title = responseData.Title || "";
              this.FirstName = responseData.FirstName || "";
              this.LastName = responseData.LastName || "";
              this.Email = responseData.Email || "";
              this.MobilePhone = responseData.MobilePhone || "";
              this.Region__c = responseData.Region__c || "";
              this.NSA_Bookingdate = responseData.NSA_Bookingdate__c || "";
              this.NSA_4x4_4x2__c = responseData.NSA_4x4_4x2__c || "";
              // this.Comments__c = responseData.Comments__c || "";
              //             NSA_4x4_4x2__c: this.NSA_4x4_4x2__c,
              // NSA_Areyoubringingkids__c: this.NSA_Areyoubringingkids__c,
              // NSA_DrivingExperience__c: this.NSA_DrivingExperience__c,
              // NSA_Inviteamate__c: this.NSA_Inviteamate__c,
              // Dietary_Requirements__c: this.selectedDietaryRequirements.join(', '),
              this.NSA_Areyoubringingkids__c =
                responseData.NSA_Areyoubringingkids__c ;
              this.NSA_DrivingExperience__c =
                responseData.NSA_DrivingExperience__c;
              this.NSA_Inviteamate__c = responseData.NSA_Inviteamate__c || "";
              this.Dietary_Requirements__c =
                responseData.Dietary_Requirements__c;
              // NSA_Inviteamate__c : this.NSA_Inviteamate__c,

              this.NSA_InviteyourMateFirstName__c = responseData.NSA_InviteyourMateFirstName__c;
              this.NSA_InviteyourMateLastName__c =responseData.NSA_InviteyourMateLastName__c;
              this.NSA_InviteyourMateMobile__c = responseData.NSA_InviteyourMateMobile__c;
              this.NSA_InviteyourMateEmail__c = responseData.NSA_InviteyourMateEmail__c;
              // NSA_Whataretheirages__c: this.NSA_Whataretheirages__c,

              this.NSA_Inviteamate__c = responseData.NSA_Inviteamate__c == "" ? false : responseData.NSA_Inviteamate__c,

              this.NSA_Whataretheirages__c =
                responseData.NSA_Whataretheirages__c || "";

              this.showForm = true;
              if (!this.isLoading && this.showForm === true) {
                setTimeout(async () => {
                  const form = document.getElementById("ownerForm");
                  if (!form) return; // Ensure the form element exists
                  // Get all input, select, checkbox, and radio elements within the form
                  const elements = form.querySelectorAll(
                    "input, select, checkbox, radio"
                  );
                  // Add focus event listener to each element
                  elements.forEach((element) => {
                    element.addEventListener("focus", this.onFocus);
                  });
                }, 500);
              }
            } else {
              this.$router.push("/");
            }
          })
          .catch((error) => {
            console.log(error);
            this.$router.push("/");
          });
      } catch (error) {
        this.$router.push("/");
      } finally {
        setTimeout(() => {
          this.isLoading = false;
        }, 750);
      }
    },
    async getAvailableBookingDates() {
      try {
        this.isLoading = true;
        const apiUrl = `${base_be_booking_url}?booking_dates=true`;

        axios
          .get(apiUrl)
          .then((response) => {
            // Handle the successful response
            const res = response.data;
            if (res.success && res.available_dates) {
              this.availableDates = res.available_dates;
              this.fetchData();
            }
          })
          .catch((error) => {
            console.log(error);
            this.$router.push("/guest");
          });
      } catch (error) {
        console.log(error);
        this.$router.push("/guest");
      } finally {
        setTimeout(() => {
          this.isLoading = false;
        }, 500);
      }
    },
    onFocus(event) {
      // console.log("Element focused:", event.target.tagName);
      if (this.isFocused === false) {
        if (!event.target.hasAttribute("data-focused")) {
          event.target.setAttribute("data-focused", true);
        }
        this.isFocused = true;
        // Adobe Analytics Starts
        let event_happened = "Form Start";
        let event_126 = "";
        let events = "event50";
        let eVar14 = event_happened;
        // let eVar14 = event_happened + "|" + url

        adobeAnalytics(
          "R",
          "",
          "",
          "",
          "",
          "EN",
          event_happened,
          "",
          "",
          "",
          event_126,
          events,
          "",
          "",
          eVar14
        );
        // Adobe Analytics Ends
      }
    },
  },
  async mounted() {
    await this.getAvailableBookingDates();
  },
};
</script>

<style>
.datepicker:hover {
  border-color: #000000 !important;
}

.loading-shade {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* background-color: rgba(255, 255, 255, 0.8); */
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.loading-spinner {
  border: 6px solid #f3f3f3;
  border-top: 6px solid #000000;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
